import Vue from 'vue'
import confirmComponent from '@/components/admin/Confirm.vue'

export const confirm = {
  methods: {
    confirm (options) {
      const ConfirmComponent = Vue.extend(confirmComponent)
      return new ConfirmComponent({
        el: document.createElement('div'),
        options
      })
    }
  }
}
